import React, { Component } from 'react'  
import { ShareModalTriggerConnected } from './Share'
import Button from './Button'

export const CARD_HEADLINE_STYLES = {
  REGULAR: 'regular',
  BIG: 'big',
}

class Card extends Component {
    render(){
      return (
        <div style={{minHeight: 260}} className="sk-card" style={{margin: '2px'}} >
          <div className="sk-card__head" onClick={this.handleClick}>
            <a href={this.props.imageLink}><img src={this.props.image} /></a>
          </div>
          <div className="sk-card__body">
            <div className="sk-card__category">{this.props.category}</div>
            <div className={`sk-card__headline sk-card__headline--${this.props.cardHeadlineStyle || 'regular'}`}>
              <a href={this.props.headlineLink}>{this.props.headline}</a>
            </div>
            <div className="sk-card__headline--level-2">
              <a href={this.props.subheadlineLink} >{this.props.subheadline}</a>
            </div>

            {
              this.props.showButtons ? 
                <div className="sk-card__buttons">
                  <span><ShareModalTriggerConnected {...this.props} /></span>
                  {
                    this.props.buttonLink ?
                      <span className="pull-right">
                        <Button link={this.props.buttonLink} 
                                label={this.props.buttonLabel}
                                backgroundImage={this.props.buttonBackgroundImage}/>
                      </span>
                    : null
                  }
                </div>
              : null
            }
          </div>
        </div>
      )
    }
  }

export default Card;